import { Injectable } from '@angular/core';
import { CARGOCHIEF_KEYS } from '@domain/constants/app-variables';
import { Cargochief } from '@service/cargochief/cargochief.service';
import {
	DATE_MDY,
	INTEGRATION_TYPE,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	VETTING_SOURCE,
} from 'cargo-chief-commons';

@Injectable({
	providedIn: 'root',
})
export class CarrierVettingService {
	constructor(private cargochief: Cargochief) {}

	logo(vettingSource: VETTING_SOURCE) {
		switch (vettingSource) {
			case VETTING_SOURCE.MY_CARRIER_PACKETS:
				return 'assets/icons/mcp_logo.png';
			case VETTING_SOURCE.RMIS:
				return 'assets/icons/rmis_logo.svg';
			case VETTING_SOURCE.C4:
			default:
				return 'assets/icons/network.svg';
		}
	}

	tooltip(vettingSource: VETTING_SOURCE, carrierOnboardedOn: Date) {
		const onboardedDate = DATE_MDY(carrierOnboardedOn);
		switch (vettingSource) {
			case VETTING_SOURCE.MY_CARRIER_PACKETS:
				return `MyCarrierPortal Onboarded: ${onboardedDate}`;
			case VETTING_SOURCE.RMIS:
				return `RMIS Onboarded: ${onboardedDate}`;
			case VETTING_SOURCE.C4:
				return `C4 Onboarded: ${onboardedDate}`;
			default:
				return '';
		}
	}

	isMCPEnabled() {
		const activeIntegrations = this.cargochief.getActiveIntegrations();
		return (
			IS_NOT_NULL_OR_UNDEFINED(activeIntegrations) &&
			activeIntegrations.includes(INTEGRATION_TYPE.MY_CARRIER_PACKETS)
		);
	}

	isRMISEnabled() {
		const activeIntegrations = this.cargochief.getActiveIntegrations();
		return (
			IS_NOT_NULL_OR_UNDEFINED(activeIntegrations) &&
			activeIntegrations.includes(INTEGRATION_TYPE.RMIS)
		);
	}

	isCarrierOnboarded(carrierId: string): boolean {
		const onboardedCarriers = this.cargochief.getItem(CARGOCHIEF_KEYS.ONBOARDED_CARRIERS);
		if (IS_NOT_NULL_OR_UNDEFINED(onboardedCarriers)) {
			const onboardedCarriersList = JSON.parse(onboardedCarriers);
			return onboardedCarriersList.includes(carrierId);
		}
		return false;
	}

	carrierInvitationSent(carrierId: string): void {
		let onboardedCarriers: any = this.cargochief.getItem(CARGOCHIEF_KEYS.ONBOARDED_CARRIERS);
		if (IS_NULL_OR_UNDEFINED(onboardedCarriers)) {
			onboardedCarriers = [carrierId];
		} else {
			onboardedCarriers = JSON.parse(onboardedCarriers);
			onboardedCarriers.push(carrierId);
		}
		this.cargochief.setItem({ [CARGOCHIEF_KEYS.ONBOARDED_CARRIERS]: onboardedCarriers });
	}
}
